import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import UpdatesPage from "../pages/updates/page";
import SeriesPage from "../pages/series/page";
import SeriesDetail from "../pages/series/detail";
import AboutPage from "../pages/about/page";
import FaqPage from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/updates",
        element: <UpdatesPage />,
      },
      {
        path: "/series",
        element: <SeriesPage />,
      },
      {
        path: "/series/:id",
        element: <SeriesDetail />,
      },
      {
        path: "/about",
        element: <AboutPage />,
      },
      {
        path: "/faq",
        element: <FaqPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;